import { State } from 'src/types'
import { thumbHook } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/thumbHook'
import { littleHook } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/littleHook'
import { laceDrawer } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/lace'
import { liningDrawer } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/liningDrawer'
import { backStyleDrawer } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/backStyleDrawer'
import { atomsLabelDrawerForCatcherMitt } from 'src/features/atoms/glove/drawer/common/useCanvasHelper'
import { canvasResetter } from 'src/util/canvas'
import { catchFaceDrawer } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/catchFaceDrawer'
import { webDrawer } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/webDrawer'
import { fingerEmbroideryDrawer } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/fingerEmbroideryDrawer'
import { fingerGuardDrawer } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/fingerGuardDrawer'

export const atomsCanvasCatcherMittBack = async (ctx: CanvasRenderingContext2D, state: State): Promise<void> => {
  canvasResetter(ctx) // リセット
  liningDrawer(ctx, state) // 裏革
  await backStyleDrawer(ctx, state) // バックスタイル
  catchFaceDrawer(ctx, state.catchFace.color, state.stitch.color, state.baseModel.productNumber) // 捕球面側
  await fingerGuardDrawer(ctx, state) // 指カバー・指当て
  fingerEmbroideryDrawer(ctx, state.embroideries) // 親指、小指の刺繍
  await webDrawer(ctx, state) // ウェブ
  laceDrawer(ctx, state.lace.color) // 革紐
  thumbHook(ctx, state.thumbHook.color) // かけ紐
  littleHook(ctx, state.littleHook.color) // かけ紐
  atomsLabelDrawerForCatcherMitt(ctx, state) // ブランドのラベル
}
